import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { AdminLayout } from '@/pages/admin/layout/AdminLayout';
import { AppLayoutSkeleton } from '@/layout/AppLayoutSkeleton';
import { requireAuthenticated } from '@/lib/auth/authSnapshot';
import { platformCan } from '@bliks-io/contracts';
import { platformRequirementForAdminPath } from '@/pages/admin/layout/adminNavigation';
import { profileQueryOptions } from '@/api/queries/useProfile';

export const Route = createFileRoute('/admin')({
  component: AdminLayoutRoute,
  // Same pending boundary as $slug (see the comment there): no delay, no minimum.
  pendingComponent: AppLayoutSkeleton,
  pendingMs: 0,
  pendingMinMs: 0,
  /**
   * Zwei Fragen, und die zweite ist neu (ADR 0042): gehört dieser Mensch zur
   * Plattform — und darf er, was **diese** Seite verlangt?
   *
   * Die Navigation blendete bisher allein aus, was nicht zur Rolle gehört.
   * Das reicht nicht: ein Link von einer erlaubten Seite, ein Lesezeichen
   * oder eine eingetippte Adresse führten trotzdem hin, und die Seite baute
   * sich auf, während jede einzelne Abfrage darin am Server abprallte. Der
   * Server hielt also dicht, die Oberfläche zeigte eine Tür, die keine war.
   *
   * Zurück auf `/admin`, nicht auf eine feste Seite: der Einstieg weiss, was
   * die Rolle als Erstes zeigen soll.
   */
  beforeLoad: async ({ location, context }) => {
    const auth = requireAuthenticated();

    if (!auth.isSuperAdmin) {
      throw redirect({ to: '/$slug', params: { slug: auth.slug } });
    }

    const requirement = platformRequirementForAdminPath(location.pathname);
    if (!requirement) return {};

    const profile = await context.queryClient.ensureQueryData(profileQueryOptions);
    if (!platformCan(profile.data?.platformRoles, requirement.action, requirement.subject)) {
      throw redirect({ to: '/admin' });
    }

    return {};
  }
});

function AdminLayoutRoute() {
  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}
